import type { GlobalToken } from 'antd'
import { createStyles } from 'antd-style'

const themedColors = (token: GlobalToken) => {
  const colors = {
    'bg-color': token.colorBgElevated,
    'text-color': token.colorTextSecondary,
    'highlight-color': token.colorPrimary,
    'hover-bg-color': token.colorFillSecondary,
    'hover-bg-color-reduced-opacity': token.colorFillTertiary,
    'focus-bg-color': token.colorFill,
    'picker-border-color': token.colorBorderSecondary,
    'search-input-bg-color': token.colorFillTertiary,
    'search-input-bg-color-active': token.colorFillTertiary,
    'category-label-bg-color': token.colorBgElevated,
    'category-icon-active-color': token.colorPrimary,
    'emoji-variation-picker-bg-color': token.colorBgElevated,
    'emoji-variation-indicator-color': token.colorBorder,
    'reactions-bg-color': token.colorBgElevated,
    'skin-tone-picker-menu-color': token.colorBgElevated
  }

  return Object.fromEntries(
    Object.entries(colors).flatMap(([name, value]) => [
      [`--epr-${name}`, value],
      [`--epr-dark-${name}`, value]
    ])
  )
}

export const useStyles = createStyles(({ token }) => ({
  popoverContent: {
    padding: 0
  },
  trigger: {
    display: 'inline-flex'
  },
  picker: {
    '.EmojiPickerReact': {
      border: 'none',
      ...themedColors(token),
      '--epr-search-input-height': `${token.controlHeightLG}px`,
      '--epr-search-input-bg-color': token.colorFillTertiary,
      '--epr-search-input-padding': `0 ${token.paddingSM}px 0 ${token.controlHeight}px`,
      '--epr-search-border-color': token.colorPrimary,
      '--epr-search-input-text-color': token.colorText,
      '--epr-search-input-placeholder-color': token.colorTextPlaceholder,
      '--epr-header-padding': `${token.paddingXS}px ${token.paddingSM}px`,
      '--epr-category-navigation-button-size': `${token.controlHeightSM}px`,
      '--epr-horizontal-padding': `${token.paddingXS}px`,
      '--epr-category-label-height': `${token.controlHeight}px`,
      '--epr-category-label-text-color': token.colorTextSecondary,
      '--epr-emoji-size': `${token.controlHeight}px`
    },
    '.epr-search-container input': {
      fontSize: token.fontSize,
      borderRadius: token.borderRadius
    },
    '.epr-emoji-category-label': {
      fontSize: token.fontSize,
      fontWeight: token.fontWeightStrong,
      paddingBlock: 0
    },
    '.epr-body': {
      paddingTop: 0
    }
  }
}))
